export default __webpack_public_path__ + "static/media/celebrations.f72b0b9e.svg";